import Loading from 'components/Loading';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import Fields from './Fields';
import queryString from "utils/queryString";
import { newMission } from 'services/mission.routes';
import { toast } from 'react-toastify';
import { updateMission } from 'services/mission.routes';

export default function NewMission() {
    const [loading, setLoading] = useState(false);
    const [information, setInformation] = useState({});
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const method = searchParams.get("method");
    const { state } = useLocation();

    const schema = yup.object().shape({
        name: yup.string().required(),
        category_id: yup.string().required(),
        description: yup.string().required(),
        badge_id: yup.string().required(),
        gem: yup.number().required(),
        target: yup.string().required(),
        percent_of_badge: yup.string().required(),
        need_to_approve: yup.string().required(),
    });
    useEffect(() => {
        if (state) {
            setInformation({
                name: state.name,
                category_id: state.category_id,
                badge_id: state.badge_id,
                description: state.description,
                gem: state.gem,
                target: state.target,
                percent_of_badge: state.percent_of_badge,
                need_to_approve: +state.need_to_approve
            });
        }
    }, [state]);

    const handleNewMission = () => {
        schema.validate(information)
            .then(async (res) => {
                if (res) {
                    let data = {};
                    const { need_to_approve, ...restInformation } = information;
                    for (let item in restInformation) {
                        if (restInformation[item]) {
                            data[item] = restInformation[item];
                        }
                    }
                    data['need_to_approve'] = +need_to_approve;
                    setLoading(true)
                    newMission(queryString(data), (isOk, data) => {
                        setLoading(false)
                        if (!isOk) {
                            return toast.error(data.message);
                        } else {
                            toast.success(`ماموریت اضافه شد`);
                            navigate('/mission')
                        }
                    });
                }
            }).catch(err => {
                return toast.error(err.errors[0])
            })
    }
    const handleUpdateMission = () => {
        if (state.id) {
            let data = {};
            const { need_to_approve, ...restInformation } = information;
            for (let item in restInformation) {
                if (restInformation[item]) {
                    data[item] = restInformation[item];
                }
            }
            data['need_to_approve'] = +need_to_approve;
            setLoading(true)
            updateMission(state.id, queryString(data), (isOk, data) => {
                setLoading(false)
                if (!isOk) {
                    return toast.error(data.message);
                } else {
                    toast.success(`ماموریت ویرایش شد`);
                    navigate('/mission')
                }
            });
        }
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Loading loading={loading} />
            <p style={{ fontSize: 16, fontWeight: "bold" }}>{method !== "update" ? "ماموریت جدید" : "ویرایش ماموریت"}</p>
            <Fields information={information} handleUpdate={handleUpdateMission} method={method} setInformation={setInformation} submit={handleNewMission} />
        </DashboardLayout>
    )
}
